/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Header, Segment } from 'semantic-ui-react';
import { Footer } from '../../components';

import './AccessibilityStatement.css';

const AccessibilityStatement = () => (
  <div className="accessibility-statement">
    <Container text style={{ marginTop: '3em', marginBottom: '2em' }}>
      <Segment raised padded="very">
        <Header as="h1" dividing color="teal">
          Dichiarazione di accessibilità
        </Header>
        <p>
          Ci impegniamo a rendere il nostro sito web accessibile, conformemente
          alla legge 9 gennaio 2004, n. 4.
        </p>

        <Header as="h2" color="teal">
          Stato di conformità
        </Header>
        <p>
          Questo sito web è parzialmente conforme ai requisiti previsti
          dall'appendice A della norma UNI CEI EN 301549 a causa delle non
          conformità elencate di seguito.
        </p>

        <Header as="h2" color="teal">
          Contenuti non accessibili
        </Header>
        <p>
          I contenuti di seguito elencati non sono accessibili per i seguenti
          motivi:
        </p>
        <ul>
          <li>
            Contrasto del colore: alcuni testi e pulsanti potrebbero avere un
            rapporto di contrasto insufficiente.
          </li>
          <li>
            Immagini: alcune immagini potrebbero non avere un testo alternativo
            adeguato.
          </li>
          <li>
            Mappe: le mappe interattive potrebbero non essere completamente
            accessibili a screen reader e tastiera.
          </li>
          <li>
            Documenti: alcuni documenti in formato PDF potrebbero non essere
            completamente accessibili.
          </li>
        </ul>

        <Header as="h2" color="teal">
          Feedback e informazioni di contatto
        </Header>
        <p>
          Per segnalare casi di mancata conformità o per richiedere informazioni
          e contenuti che sono al di fuori dell'ambito della direttiva, si prega
          di contattarci all'indirizzo email:{' '}
          <strong>
            <a href="mailto:accessibilitaweb@a2a.it">accessibilitaweb@a2a.it</a>
          </strong>
        </p>

        <Button as={Link} to="/" color="teal" style={{ marginTop: '1em' }}>
          Torna alla Home
        </Button>
      </Segment>
    </Container>
    <Footer />
  </div>
);

export { AccessibilityStatement };
